import { SubNav } from "@/components/SubNav"
import { OrgSwitcher } from "@/components/OrgSwitcher"

/**
 * The Automations module's tab strip. Overview and History are two views of the
 * same org-scoped thing, so the scope picker sits beside them rather than in the
 * sidebar. Shared by both index pages so they cannot drift apart.
 *
 * History kept its own top-level /runs route — the list is cross-automation and
 * org-scoped, with automation as a filter — so the tabs match on prefixes rather
 * than on the default path-nesting rule.
 */
export function AutomationsSubNav() {
  return (
    <SubNav
      ariaLabel="Automations sections"
      items={[
        {
          href: "/automations",
          label: "Overview",
          active: (url) => url.startsWith("/automations"),
        },
        {
          href: "/runs",
          label: "History",
          active: (url) => url.startsWith("/runs"),
        },
      ]}
      actions={<OrgSwitcher />}
    />
  )
}
